<script setup>
import { ref } from 'vue'
import OutlineButton from '../buttons/OutlineButton.vue'
const props = defineProps({
    upperTitle: {
        type: String,
        default: 'L’application révolutionnaire'
    },
    title: {
        type: String,
        default: 'Un agent IA dédié aux commissaires de justice'
    },
    buttonLabel: {
        type: String,
        default: 'Découvrir'
    },
    heroFirstVideoSrc: {
        type: String,
        default: '/videos/discover-orion.mp4'
    },
    heroSecondVideoSrc: {
        type: String,
        default: '/videos/full-video.mp4'
    }
})

</script>

<template>
    <section class="hero-banner">
        <div class="hero-content">
            <p class="hero-upper-title">{{ upperTitle }}</p>
            <h1 class="hero-title">{{ title }}</h1>
            <OutlineButton
                class="hero-btn"
                :label="buttonLabel"
                link="/contact#formulaire"
            />
        </div>
        <div class="hero-image">
            <NuxtImg
                src="/images/iPhone_Mockup_1.webp"
                layout="fill"
                objectFit="cover"
                alt="iPhone Mockup"
                loading="eager"
            />
        </div>
    </section>
</template>

<style lang="scss" scoped>
.hero-banner {
    display: flex;
    align-items: start;
    justify-content: space-between;
    max-width: 1350px;
    margin: 0 auto;
    flex-direction: column;
    gap: 40px;  
    padding-top: 125px;
    min-height: 115vh;

    & .hero-content {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 15px;
        width: 100%;
        max-width: 525px;
        position: relative;

        &::before{
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            width: 800px;
            max-width: 99vw;
            height: 650px;
            border-radius: 791px;
            opacity: 0.3;
            background: rgba(48, 162, 255, 0.7);
            filter: blur(150px);
            transform: translate(-48%, -36%);
        }

        & .hero-upper-title {
            text-align: center;
            font-family: $tertiary-font-family;
            font-size: $upper-title-size;
            line-height: $upper-title-line-height;
            margin: 0;
            background: $title-background-gradient--blue;
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

    
        & .hero-btn {
            margin-top: 20px;
        }
    }

    & .hero-image {
        width: 100%;
        display: flex;
        justify-content: center;
        height: 100%;
        position: absolute;
        right: 0;
        z-index: 0;
        pointer-events: none;
        top: 290px;

        & img{
            width: 100%;
            height: 115%;
            object-fit: contain;
            object-position: top center;
        }
    }

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url(/images/stars.webp);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center right;
    }
}

// Responsive
@media (min-width: 767px) {
    .hero-banner {
        min-height: unset;

        & .hero-content {
            text-align: left;
            align-items: flex-start;
            margin-top: 10vh;
        }

        min-height: 100vh;
        flex-direction: row;
        gap: 50px;  

        & .hero-upper-title{
            font-size: 28px;
        }

        & .hero-videos:before, 
        & .hero-videos::after{
            width: 175px;
        }

        & .hero-image{
            top: 0;
        }
    }
}

</style>